import { UploadFile } from "antd";
import { RcFile } from "antd/es/upload";
import { v4 as uuid } from "uuid"
import { getBase64 } from "./base64";

export function castArray<T = any>(val: T | T[]): T[] {
    if (!val && val !== 0) {
        return [];
    }

    return Array.isArray(val) ? val : [val];
}

export const processFile = async (fileObject: RcFile): Promise<UploadFile> => {
    try {
        const base64 = await getBase64(fileObject);

        const uploadFile: UploadFile = {
            name: fileObject.name,
            size: fileObject.size,
            uid: uuid(),
            thumbUrl: base64.toString(),
            preview: base64.toString(),
            originFileObj: fileObject,
            type: fileObject.type,
        };

        return uploadFile;
    } catch (error) {
        console.error("Error processing file:", error);
        throw new Error(`Failed to process file: ${fileObject.name}`);
    }
};